export const euroVatCountryCodes = [
	'AT',
	'BE',
	'BG',
	'CH',
	'CZ',
	'DE',
	'DK',
	'ES',
	'FI',
	'FR',
	'MC',
	'GB',
	'IE',
	'IT',
	'NL',
	'NO',
	'PL',
	'CY',
	'EE',
	'GR',
	'HR',
	'HU',
	'LT',
	'LU',
	'LV',
	'MT',
	'PT',
	'RO',
	'SI',
	'SK',
];
export const gstCountries = ['CA', 'HK', 'SG'];
export const pstCanadianProvinces = ['BC', 'MB', 'SK'];
export const subdivisionCountries = ['US', 'CA'];
